import { Controller } from '@hotwired/stimulus';

import { useEvent } from '@/utils/useEventListener';

export default class extends Controller {
  static targets = ['fieldset', 'error'];

  static values = {
    errorMessage: String,
  };

  connect() {
    useEvent(this, 'submit', this.disable);
    useEvent(this, 'submit', this.hideError);
    useEvent(this, 'turbo:submit-end', this.enable);
    useEvent(this, 'turbo:fetch-request-error', this.showError);
  }

  disable() {
    const fieldset = this.fieldsetTarget;
    if (fieldset) {
      // Use setTimeout to ensure the form submission process is not interrupted
      // by disabling the fieldset immediately. Otherwise, form inputs may not
      // be included in the submission.
      setTimeout(() => {
        fieldset.disabled = true;
      }, 1);
    }
  }

  enable() {
    const fieldset = this.fieldsetTarget;
    if (fieldset) {
      fieldset.disabled = false;
    }
  }

  showError(event) {
    if (this.hasErrorTarget) {
      this.errorTarget.hidden = false;
      this.errorTarget.replaceChildren(
        <details>
          <summary>{this.#message}</summary>
          {event.detail?.error && (
            <em className="inline-block mt-2">
              {event.detail.error.toString()}
            </em>
          )}
        </details>,
      );
    }
  }

  hideError() {
    if (this.hasErrorTarget) {
      this.errorTarget.hidden = true;
      this.errorTarget.innerHTML = '';
    }
  }

  get #message() {
    return (
      this.errorMessageValue ||
      'An error occurred while submitting the form. Please check your internet connection and try again.'
    );
  }
}
